import { Routes } from '@angular/router';
import {MyProfileComponent} from "../modules/shared/shared-views/my-profile/my-profile.component";
import {OnboardGuard} from "../guards/onboard.guard";

// TODO CREATE CAM ACTIVATE FOR ADMIN ONLY STUFF

const Routing: Routes = [


  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: '',
    canActivate: [OnboardGuard],
    children:[
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'test',
        loadChildren: () =>
          import('./core/test-functionality/test-functionality.module').then((m) => m.TestFunctionalityModule),
      },
      {
        path: 'campaigns',
        loadChildren: () =>
          import('./core/campaigns/campaigns.module').then((m) => m.CampaignsModule),
      },
      {
        path: 'events',
        loadChildren: () =>
          import('./core/events/events.module').then((m) => m.EventsModule),
      },
      {
        path: 'donations',
        loadChildren: () =>
          import('./core/donations/donations.module').then((m) => m.DonationsModule),
      },
      {
        path: 'donors',
        loadChildren: () =>
          import('./core/donors/donors.module').then((m) => m.DonorsModule),
      },
      {
        path: 'finance',
        loadChildren: () =>
          import('./core/finance/finance.module').then((m) => m.FinanceModule),
      },
      {
        path: 'emails',
        loadChildren: () =>
          import('./core/emails/emails.module').then((m) => m.EmailsModule),
      },
      {
        path: '',
        redirectTo: '/dashboard'
      },
    ]
  },


  {
    path: 'my-profile',
    component: MyProfileComponent
  },

  {
    path: '**',
    redirectTo: 'error/404',
  },
];

export { Routing };
